export default {
    methods: {
        toggleCartImportXlsModal(state) {
            this.$emitter.emit('toggleCartImportXlsModal', state)
        }
    }
}
